import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { ComponentLoaderDirective } from '@shared/directives';
import { LegalModalComponent } from '@shared/components/legal';

@Component({
  selector: 'app-legal-links',
  templateUrl: './legal-links.component.html',
  styleUrls: ['./legal-links.component.scss']
})
export class LegalLinksComponent implements OnInit, OnDestroy {
  @Input() styleClass = '';
  @Input() showAcceptButton = false;
  @Output() termsAccepted = new EventEmitter<boolean>();
  @Output() legalModalClosed = new EventEmitter<void>();

  @ViewChild(ComponentLoaderDirective, { static: true })
  loaderDirective!: ComponentLoaderDirective;

  baseUrl!: string;

  private destroy$ = new Subject<void>();

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Remove fragment to support nested routing use cases
    const [base] = this.router.url.split('#');
    this.baseUrl = base;
  }

  ngOnDestroy(): void {
    this.loaderDirective.viewContainerRef.clear();
    this.destroy$.next();
    this.destroy$.complete();
  }

  openLegalModal(section: 'eula' | 'privacy', onAccepted?: () => void): void {
    const container = this.loaderDirective.viewContainerRef;
    container.clear();

    const componentRef = container.createComponent(LegalModalComponent);
    componentRef.instance.showModal = true;
    componentRef.instance.activeSection = section;

    // Show accept button only for EULA
    componentRef.instance.showAcceptButton = section === 'eula' && this.showAcceptButton;

    componentRef.instance.termsAccepted
      .pipe(takeUntil(this.destroy$))
      .subscribe((accepted: boolean) => {
        if (accepted) {
          this.handleAccept();
          onAccepted?.(); // call a function to trigger only if accepted
        }
      });
  }

  private handleAccept(): void {
    this.termsAccepted.emit(true);
    this.showAcceptButton = false;
  }
}
